import React from 'react';
import { Quote } from 'lucide-react';

export function RainbowBridgeQuote() {
  return (
    <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg mb-12">
      <div className="flex items-center gap-4 mb-6">
        <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
          <Quote className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
        </div>
        <h2 className="card-title">
          Tęczowy Most
        </h2>
      </div>
      
      <blockquote className="prose prose-lg dark:prose-invert max-w-none">
        <p className="body-large italic">
          "Jest takie miejsce zwane Tęczowym Mostem, które łączy niebo i ziemię. Gdy zwierzę umiera, 
          szczególnie takie, które było kimś bardzo bliskim, udaje się do tego miejsca. W krainie za 
          Tęczowym Mostem są łąki i wzgórza, na których nasi przyjaciele mogą biegać i bawić się razem. 
          Jest tam pod dostatkiem jedzenia, wody i słońca, a nasi przyjaciele czują się dobrze i nie 
          cierpią. Wszystkie zwierzęta, które były chore i stare, znów stają się młode i zdrowe. 
          Te, które zaginęły, zostały zranione lub były nieszczęśliwe, znów są szczęśliwe i pełne życia. 
          Zwierzęta za Tęczowym Mostem mogą biegać i bawić się razem."
        </p>
        <p className="body-large italic">
          "Jedyną rzeczą, której im brakuje, jesteśmy my, ich bliscy, których zostawili na ziemi. 
          Każde ze zwierząt biegnie i skacze z radości, gdy widzi, że ktoś szczególny dla niego zbliża się do Mostu. 
          Wtedy razem przekraczają Tęczowy Most, by już nigdy się nie rozstać..."
        </p>
        <footer className="text-right mt-4">
          <p className="body-medium text-accessible-gray-600 dark:text-accessible-gray-400 high-contrast:text-white/80">
            — autor nieznany
          </p>
        </footer>
      </blockquote>
    </div>
  );
}